export const logout = function () {
  localStorage.removeItem("user");
  window.location.reload();
};
